import { targetParamMap } from '@smartproxy/sp-utils';

import { UseFormReturn } from '@/hooks/useForm';
import { useTranslation } from '@/lib/i18n/i18n.client';

import Button from '@/decodo/components/atoms/Button';
import { Text } from '@/decodo/components/atoms/Text';

import { Spinner } from '@/decodo/components/atoms/spinner';
import { useScraper } from '../state/context';
import { FormField } from './FormField';

type ConfigFormProps = {
  form: UseFormReturn<Record<string, string>>;
  handleScrape: (values: Record<string, string>) => void;
  isScraping: boolean;
};

export const ConfigForm = ({
  form,
  handleScrape,
  isScraping,
}: ConfigFormProps) => {
  const { target } = useScraper();
  const { texts } = useTranslation();

  const params = targetParamMap[target.name];

  const primaryParams = params.filter((param) => param.group === 'primary');
  const otherParams = params.filter((param) => param.group === 'regular');

  return (
    <form
      className='flex h-full flex-col gap-5'
      onSubmit={form.handleSubmit(handleScrape)}
    >
      <div className='flex-1 flex-col gap-5 overflow-y-auto p-2'>
        <div className='gap-z text-label-medium mb-4 flex flex-col text-left'>
          {primaryParams.map((param) => (
            <FormField key={param.key} form={form} param={param} />
          ))}
        </div>
        {otherParams.length > 0 && (
          <div className='flex flex-col gap-4 overflow-hidden'>
            <div className='w-full text-left'>
              <Text className='text-label-medium font-serif uppercase text-gray-500 dark:text-gray-400'>
                {texts.scraper.set_parameters}
              </Text>
            </div>
            <div className='flex h-full flex-col gap-3 overflow-y-auto'>
              {otherParams.map((param, i) => (
                <div key={param.key} style={{ zIndex: otherParams.length - i }}>
                  <FormField form={form} param={param} />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className='-mt-1'>
        <Button
          color='secondary'
          fullwidth
          disabled={isScraping}
          rightSection={isScraping && <Spinner />}
        >
          {isScraping
            ? texts.scraper.sending_request
            : texts.scraper.send_request}
        </Button>
      </div>
    </form>
  );
};
